import { type SliderSingleProps } from 'antd/es/slider'

export enum CustomizerSize {
  XS = 'XS',
  S = 'S',
  M = 'M',
  L = 'L',
}

export const pinSizes: Record<number, number> = {
  0: 0.1,
  1: 0.15,
  2: 0.2,
  3: 0.25,
}

export const lineSizes: Record<number, number> = {
  0: 2,
  1: 3,
  2: 4,
  3: 5,
}

export enum CustomizerColor {
  Red = '#E74C3C',
  Blue = '#3498DB',
  Green = '#27AE60',
  Yellow = '#F39C12',
  Purple = '#9B59B6',
  Orange = '#E67E22',
  Black = '#000000',
  Gray = '#5A5A5A',
  Brown = '#8B4513',
  Pink = '#E91E63',
  Teal = '#16A085',
  Lime = '#7CB342',
  Maroon = '#800000',
  Navy = '#001F3F',
  Olive = '#6B7A00',
  Silver = '#95A5A6',
  Tan = '#BC8F8F',
  Success = '#5D8C61',
  Attention = '#D68910',
  Site = '#2C3E34',
}

export const predefinedColors = [
  { label: 'Black', value: CustomizerColor.Black },
  { label: 'Red', value: CustomizerColor.Red },
  { label: 'Blue', value: CustomizerColor.Blue },
  { label: 'Green', value: CustomizerColor.Green },
  { label: 'Yellow', value: CustomizerColor.Yellow },
  { label: 'Purple', value: CustomizerColor.Purple },
]

export const pinMarkers: SliderSingleProps['marks'] = {
  0: CustomizerSize.XS,
  1: CustomizerSize.S,
  2: CustomizerSize.M,
  3: CustomizerSize.L,
}

export const lineMarkers: SliderSingleProps['marks'] = {
  0: CustomizerSize.XS,
  1: CustomizerSize.S,
  2: CustomizerSize.M,
  3: CustomizerSize.L,
}
